module.exports = __webpack_public_path__ + "img/how-might-desktop.abc30770.svg";